export default {
  xzsj: '选择日期',
  qsr: '请输入',
  qxz: '请选择',
  zwsj: '暂无数据',
  yxqgq: '月需求已超过办理日期，不可使用！',

  gjly:'国际联运',
  gnys:'国内运输',
  jdxq:'阶段需求',
  yxqh:'月需求号',
  xqdh:'需求单号',
  faz:'发站',
  daoz:'到站',
  pm:'品名',
  hwmc:'货物名称',
  kydcs:'可预定车数',

  fhxx: '发货信息',
  shxx: '收货信息',
  jbr:'经办人',
  hz:'货主',
  tyrjs:'托运人记事',
  zjh:'证件号',
  tyr:'托运人',
  jbrsj:'经办人手机',
  zzzmwj:'资质证明文件',
  mc:'名称',
  hm:'号码',
  zcdd:'装车地点',
  xcdd:'卸车地点',
  scfj: '上传附件',
  cyshf: '常用收货方',
  shr: '收货人',
  txdz: '通信地址',
  fkxx:'付款信息',
  yfk: '预付款',
  xj:'现金',
  fkr:'付款人',
  zffs:'支付方式',
  bzxz:'币种选择',
  biz:'币种',
  jp:'基普',
  rmb:'人民币',
  meij:'美金',
  ldwl:'两端物流',
  ldwlw: '可根据您的需求，选择录入发到站接取，送达，仓储等物流服务信息。',
  qk:'清空',
  tj: '提交',

  xl: '箱类',
  xx: '箱型',
  zaiz: '载重',
  ziz: '自重',
  jwjtdcc:'将文件拖到此处，或',
  djsc:'点击上传',
  hang:'行',
  xhgscw:'箱号，格式错误',
  zhyw:'最后一位',
  ddxx:'订单信息',
  qhjqkbd:'切换运输类型将清空已经填写的内容，请确认！',
  md:'磨丁',
  nd:'纳堆',
  lblb:'琅勃拉邦',
  wxn:'万象南',
  mengs:'孟赛',
  gax:'嘎西',
  wanr:'万荣',
  pengh:'蓬洪',
  moh: '磨憨',
  hq:'获取',
  hsxx:'核实信息',

  gryhwfblgjlyyw:'个人用户无法办理国际联运业务!',
  gryhbzgrshqhqyhh: '个人用户无法办理国际联运业务，请确定与企业绑定经办人，并在个人设置-用户切换中切换成企业用户',
  bqhcqyyhdl:'当前登录用户无发货权限，请确定与企业绑定经办人，并切换成企业用户登录',
  czsb:'操作失败',
  zyjs:'自由记事',
  fkfs:'付款方式',
  yjyf:'预计运费',
  dqyhwfhqx:'当前登录用户无发货权限,暂时无法办理业务!',
  bxwdy0os:'必须为大于0的偶数!',
  qsrtdyy:'请输入退订原因!',
  bytd:'本月退订!',
  tdtip:'次,大于等于5次后将不可新增月需求!',
  tdtip2:'退订成功!',
  jdxqsywb:'此阶段需求已使用完毕，请换其他阶段需求进行填报!!',
  zntjdtbsj:'只能提交待提报数据!',
  zkxzytdd:'只可选择一条数据!',
  yxbtitle2:'只可操作本月及下月的订单!',
  qxzsltgddd:'请选择受理通过的订单!',
  qxsrsjh:'请先输入手机号',
  pd:'派单',
  jsqdlx:'接取送达类型',
  qzssr3wzf:'请至少输入三位数字',
}
